import { ApiError } from "./api";

/**
 * What the bulk-import dialogs (employees, users) say when the import request
 * fails.
 *
 * A 413 means the file is bigger than the API will read in one request (the
 * backend's `JSON_BODY_LIMIT`). The server's own wording, "request entity too
 * large", doesn't tell an HR manager what to do next, so say it plainly.
 */
export function importFailureMessage(e: unknown): string {
  if (e instanceof ApiError && e.status === 413) {
    return "This file is too large to import in one go. Split it into smaller files and import each one.";
  }
  if (e instanceof Error) return e.message;
  return "Unexpected error";
}
